import React, {useEffect} from 'react'
import HomeTop from './HomeTop'
import HomeFooter from './HomeFooter'
// import { useNavigate } from "react-router-dom";

function ResiproPrivacyPolicy() {
    // const navigate = useNavigate();
     useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top on component mount
          }, []);
    return (
        <>
            <HomeTop />

            <div className='PrivacyPolicyOuter whiteBG'>
                <div className='container'>
                    <div className='adminBannerContent PrivacyPolicyMain'>
                        <h1>Resipro Privacy Policy</h1>
                        <p>Alptech Software Solutions recognizes the importance of protecting information we may collect when you use our ResiPro app. Our policy is to use the information we acquire from our customers through the registration process or through user postings on our app for internal business purposes only, and we maintain appropriate security measures to keep this information private.</p>
                        <br></br>
                        <p>Any personal information provided will only be used by Alptech Software Solutions, its agents or trusted suppliers as part of our ongoing efforts to provide our customer’s with superior service.</p>
                        <br></br>
                        <h2>We may collect the following types of information:</h2>
                            <p>•	Personal Information: Name, email address, and other details you provide during signup.</p>
                            <p>•	Resident Data: Details such as invoices, notices, events, complaints, polls, support tickets, visitors and other details.</p>
                            <p>•	Device Information: IP address, operating system, and app usage data for analytics and performance improvement.</p>

                        <br></br>
                        <h2>We use the collected information to:</h2>
                        <p>•	Streamline all the society related activities for residents.</p>
                        <p>•	Provide app features and improvements.</p>
                        <p>•	Ensure data security and prevent fraud.</p>
                        <p>•	Communicate with you for updates or support.</p>

                        <br></br>
                        <h2>Data Sharing and Security:</h2>
                        <p>•	We do not sell or share your personal information with third parties without your consent.</p>
                        <p>•	Data is encrypted and stored securely to protect it from unauthorized access.</p>
                        <p>•	Third-party services we use (e.g., analytics or cloud storage) comply with data privacy regulations.</p>

                        <br></br>
                        <h2>You have the right to:</h2>
                        <p>•	Access or update your personal information.</p>
                        <p>•	Delete your account and associated data.</p>

                        <br></br>
                        <p>We may update this Privacy Policy from time to time. Changes will be notified via app updates or email.</p>
                        
                        <br></br>
                        <h2>Contact Us:</h2>
                        <p>If you have any questions or concerns about this Privacy Policy, please contact us:</p>
                        <p>Email: tanmay.samal@alptechsoftware.com </p>

                        <p>By using ResiPro App, you agree to this Privacy Policy.</p>
                    </div>
                </div>
            </div>

            <HomeFooter />
        </>
    )
}

export default ResiproPrivacyPolicy